<app-layout-main [pageMetadata]="{ title: originalAppName() }" [layoutSize]="'small'" [design]="'focused'">
	<lib-focused-card [title]="'Sign up'">
		<mod-sign-up-form [useFullSize]="false" [showFieldNames]="true"></mod-sign-up-form>

		<div class="push-top">
			<lib-link [routerLink]="loginRouterLink" [linkStyle]="'default'">Already have an account? Login</lib-link>
		</div>
	</lib-focused-card>
</app-layout-main>
